// Validazione delle fasce (condizioni) e delle loro operazioni

// Filtro che richiede la select Parametri
export const FILTRO_CON_PARAMETRI = 8;

const isVuoto = (value) =>
  value === null || value === undefined || String(value).trim() === "";

export const nomeFascia = (fascia) =>
  fascia.idFascia === 0 ? "Base" : `Fascia ${fascia.idFascia}`;

// Campi obbligatori della fascia (la Base non li mostra)
export const erroriFascia = (fascia) => {
  const isBase = fascia.idFascia === 0;
  return {
    provenienzaIdValore: !isBase && isVuoto(fascia.provenienzaIdValore),
    tipoSconto: !isBase && isVuoto(fascia.tipoSconto),
    sconto: !isBase && isVuoto(fascia.sconto),
  };
};

// Campi obbligatori di un'operazione
export const erroriOperazione = (operazione) => ({
  idFiltro: isVuoto(operazione.idFiltro),
  parametro1:
    operazione.idFiltro === FILTRO_CON_PARAMETRI &&
    isVuoto(operazione.parametro1),
  idTipologia: isVuoto(operazione.idTipologia),
  condizione: isVuoto(operazione.condizione),
});

const hasErrori = (errori) => Object.values(errori).some(Boolean);

// Primo errore della fascia, null se valida
export const erroreFascia = (fascia) => {
  if (hasErrori(erroriFascia(fascia))) {
    return `${nomeFascia(fascia)}: compila provenienza, tipo sconto e sconto.`;
  }
  if (
    fascia.operazioni?.some((operazione) =>
      hasErrori(erroriOperazione(operazione)),
    )
  ) {
    return `${nomeFascia(fascia)}: compila tutti i campi delle condizioni.`;
  }
  return null;
};
